import { styled } from 'styled-components'

import { Typography } from '../../Typography'
import { SegmentCard } from '../Segment/Segment.Styled'

export const StyledContainer = styled(SegmentCard)``

export const StyledHeaderContainer = styled.div`
  display: flex;
  padding: 10px;
`

export const StyledStoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
`

export const StyledStory = styled(Typography)`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4; /* Display 5 lines by default */
`

export const StyledImagesContainer = styled.div`
  display: grid;
  padding: 2px;
  gap: 4px;
  grid-template-columns: repeat(2, 1fr);
`

export const StyledImage = styled.img`
  overflow: hidden;
  width: 100%;
  height: 100%;
  border-radius: ${({ theme }) => theme.radius['Radius XS']}px;
  object-fit: cover;
`

export const StyledActionsContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr auto;
`
